<template>
  <div class="title-tip" :class="[type]" v-if="type">
    <i class="iconfont" :class="`icon${typeData.icon}`"></i>
    <div class="text" v-html="typeData.text"></div>
    <div class="link-text" @click="link($getWikiLink('commercial'))">了解更多</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      // type: 'success', // success warning danger
      success: {
        text: '企业会员导出视频，可用于商用传播途径。',
        linkText: '了解更多',
        icon: 'a-lujing13428',
        iconColor: '',
        textColor: '',
        bgColor: '',
      },
      warning: {
        text: '个人会员导出视频，仅限个人商用，不可商用。',
        linkText: '了解更多',
        icon: 'a-lujing13428',
        iconColor: '',
        textColor: '',
        bgColor: ''
      },
      danger: {
        text: `非企业会员导出视频，不可用于商用途径，<span style="color: #FFA700">存在法律侵权风险<span>。`,
        linkText: '了解更多',
        icon: 'a-jianqu1',
        iconColor: '',
        textColor: '',
        bgColor: ''
      },
      success2: {
        text: '标准会员导出视频，可用于商用传播途径。',
        linkText: '了解更多',
        icon: 'a-lujing13428',
        iconColor: '',
        textColor: '',
        bgColor: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      'isEenterprise',
      'isSolo',
      'isTmpSolo',
      'isPoor',
      'UserMsg',
      'CommercialRisk',
      'UserMsg',
      'UserLevelInfo'
    ]),
    hasCommercialRisk () {
      return this.CommercialRisk && this.CommercialRisk.length;
    },
    type () {
      const userMsg = this.UserMsg;
      const isShopLevel = userMsg.levelType === 0 && userMsg.level > 0 && userMsg.levelNewType === 6;
      let ret = 'danger';
      if ((this.isEenterprise || isShopLevel) && !this.hasCommercialRisk) {
        ret = 'success';
      }
      if ((this.UserLevelInfo.levelName === 'standard') && !this.hasCommercialRisk) {
        ret = 'success2';
      }
      // if (this.isPoor || this.isSolo || this.UserMsg.tmpLevel || this.UserMsg.tmpLevelType) {
      //   ret = 'danger';
      // }
      // else if (this.isSolo && !this.hasCommercialRisk) {
      //   ret = 'warning';
      // }
      return ret;
    },
    typeData () {
      return this[this.type];
    }
  },
  methods: {
    link (href) {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = href;
      a.click();
      a.remove();
    }
  }
}
</script>

<style lang="scss" scoped>
a, a:hover, a:focus, a:active {
  text-decoration: none;
  color: inherit;
}
.title-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 348px;
  height: 30px;
  border-radius: 20px 20px 20px 20px;
  padding-left: 14px;
  padding-right: 14px;
  & > .text {
    padding-left: 6px;
  }
  & .link-text {
    text-decoration: underline;
    cursor: pointer;
  }
  &.success,
  &.success2 {
    color: #52C41A;
    background-color: rgba(#52C41A, .1);
    .icon {
      color: #52C41A;
    }
  }
  &.warning {
    color: #FFA700;
    background-color: rgba(#FFA700, .1);
    .icon {
      color: #FFA700;
    }
  }
  &.danger {
    color: #8D8D8D;
    background-color: rgba(#8D8D8D, .1);
    .icon {
      color: #8D8D8D;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/partTitleTip.vue